import React from 'react';
import {
  IconShare,
  IconContract,
  IconApproval,
  IconReward,
} from '@/icons';

export default {
  howItWorks: {
    title: 'Como funciona nosso programa de indicação',
    linkLabel: 'Ver regulamento',
    linkUrl: 'https://www.hostgator.com.br/termos-de-servico#programa-de-indicacao',
    steps: [
      {
        id: 1,
        icon: IconShare,
        step: 'Passo 1',
        title: 'Compartilhe o link',
        description: 'Copie o link acima e envie para seus amigos.',
      },
      {
        id: 2,
        icon: IconContract,
        step: 'Passo 2',
        title: 'Indicado contrata',
        description: 'Ele contrata um plano pelo seu link.',
      },
      {
        id: 3,
        icon: IconApproval,
        step: 'Passo 3',
        title: 'Aprovação',
        description: 'A compra é validada após 45 dias.',
      },
      {
        id: 4,
        icon: IconReward,
        step: 'Passo 4',
        title: 'Recompensa',
        description: 'Com tudo aprovado, sua recompensa é liberada!',
      },
    ],
  },
  faq: {
    title: 'Perguntas frequentes',
    items: [
      {
        id: 1,
        title: 'O que é o programa Indique e Ganhe?',
        description: (
          <>
            É um programa da HostGator que recompensa você por indicar novos clientes! 🧡
            <br />
            <br />
            {'Você compartilha seu '}
            <span>link único de indicação</span>
            {', e quando alguém contrata um plano de hospedagem por ele, você ganha '}
            <span>uma recompensa em gift card.</span>
          </>
        ),
      },
      {
        id: 2,
        title: 'Quem pode participar?',
        description: (
          <>
            {'Qualquer cliente ativo da HostGator pode participar e fazer indicações. '}
            <br />
            {'O indicado precisa ser um novo cliente, ou seja, '}
            <span>não pode ter nenhum produto ativo nos últimos 12 meses.</span>
          </>
        ),
      },
      {
        id: 3,
        title: 'Como faço pra indicar alguém?',
        description: (
          <>
            1- Acesse o Portal do Cliente, e clique em Indique e ganhe.
            <br />
            {'2- '}
            <span>Copie seu link</span>
            {' único de indicação.'}
            <br />
            {'3- Envie o '}
            <span>link por WhatsApp, e-mail ou redes sociais.</span>
            <br />
            <br />
            Quando o seu amigo contratar um plano pelo seu link, a indicação será registrada automaticamente.
          </>
        ),
      },
      {
        id: 4,
        title: 'Posso indicar quantas pessoas quiser?',
        description: 'Você pode indicar até 5 amigos por mês todos os meses.',
      },
      {
        id: 5,
        title: 'Quando a minha recompensa é liberada?',
        description: 'A recompensa é liberada em até 45 dias após a contratação do indicado, desde que ele não cancele o plano. Durante esse período, o status da sua indicação ficará "Em análise".',
      },
      {
        id: 6,
        title: 'E se a pessoa que indiquei cancelar a compra?',
        description: (
          <>
            {'Se o indicado '}
            <span>cancelar em até 45 dias</span>
            {', a indicação é '}
            <span>negada</span>
            {' e a recompensa não é gerada.'}
          </>
        ),
      },
      {
        id: 7,
        title: 'Qual é o prazo pra resgatar a recompensa?',
        description: (
          <>
            Você tem até 12 meses pra resgatar, a partir da data de aprovação.
            <br />
            {'Depois desse período, '}
            <span>ela expira automaticamente.</span>
          </>
        ),
      },
    ],
  },
  genericError: {
    title: 'Algo deu errado',
    info: 'Por favor tente novamente mais tarde',
  },
};
